(function () {
    'use strict';

    function sharingDetails() {
        return {
            restrict: 'E',
            templateUrl: 'workflow/directives/templates/sharingDetails.html',
            scope: {
                phaseIndex: '@',
                entitySearchIndex: '@',
                adminEntitySearchIndex: '@',
                path: '@',
                partners: '=',
                message: '@',
                canAddPartners: '='
            },
            link: function (scope, element, attrs) {
                if ('fullWidth' in attrs) {
                    element.children(':first').addClass('sharing-details-full-width');
                }

                scope.sharingState = '';

                if (Number.isNaN(parseInt(scope.phaseIndex))) {
                    scope.sharingState = scope.path.indexOf('InternalContent') !== -1
                        ? 'workflow.sharingsearch.internalfiles'
                        : 'workflow.sharingsearch';
                }
                else {
                    scope.sharingState = 'workflow.sharingsearch.phase';
                }
            }
        };
    }

    sharingDetails.$inject = [];

    angular.module('ecap.workflow').directive('sharingDetails', sharingDetails);
})();

